import React from 'react';

import BreadcrumbAndGoBack from '../BreadcrumbAndGoBack2';
import CommonHeader from '../CommonHeader';
import { MarkMinerviniReportText } from '../SearchReport.helper';
import styles from '../style.module.scss';

const MarkMinerviniHeader = (props) => {
  const {
    reportType,
    reportSubType,
    goBack,
    isLoading,
    currentSearchCriteria,
    reportTitle,
    fetchReportName,
    fetchingName,
    breadcrumb,
    isFilterEmpty,
    handleFilterValueClick,
    handleReset,
    setShowMinerviniText,
    showMinerviniText,
    history,
    searchReportTitle,
    note,
  } = props;
  return (
    <>
      <BreadcrumbAndGoBack
        reportType={reportType}
        reportSubType={reportSubType}
        goBack={goBack}
        isLoading={isLoading}
        currentSearchCriteria={currentSearchCriteria}
        reportTitle={reportTitle}
        fetchReportName={fetchReportName}
        fetchingName={fetchingName}
        breadcrumb={breadcrumb}
        history={history}
      />
      <div className={styles.symbolSearchContentBox}>
        <div
          className={styles.titleContainer}
          style={{
            marginBottom: '12px',
          }}
        >
          <div
            className={styles.titleContent}
            style={{
              gap: '12px',
            }}
          >
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                gap: '8px',
                alignItems: 'center',
              }}
            >
              <h3
                style={{
                  lineHeight: '20px',
                  fontSize: '20px',
                }}
              >
                {searchReportTitle}
              </h3>
              <p
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  textAlign: 'center',
                  margin: '0px',
                  color: 'var(--whitecolor)',
                }}
              >
                Note: The watchlist added here will appear in the "My Universe"
                section under the TS Watchlist.
              </p>
              <p
                style={{
                  fontWeight: 'bold',
                  fontSize: '12px',
                  textAlign: 'center',
                  margin: '0px',
                  color: 'var(--whitecolor)',
                }}
              >
                <span style={{ color: 'red' }}>
                  {note[reportSubType || reportType]?.length > 2 ? '*' : ''}
                </span>{' '}
                {note[reportSubType || reportType]}
              </p>

              <button
                style={{
                  backgroundColor: '#414a4c',
                  alignItems: 'center',
                  width: '200px',
                }}
                onClick={() => setShowMinerviniText(!showMinerviniText)}
              >
                {showMinerviniText
                  ? 'Click here to Hide Text'
                  : 'Click here to learn more'}
              </button>
              {showMinerviniText ? (
                <div
                  style={{
                    textAlign: 'left',
                    width: '100%',
                    fontSize: '15px',
                    color: 'var(--whitecolor)',
                  }}
                >
                  <MarkMinerviniReportText
                    showMinerviniText={showMinerviniText}
                  />
                </div>
              ) : null}
            </div>
          </div>
        </div>

        {isFilterEmpty.length > 0 && (
          <div className={styles.filterValueBox}>
            <CommonHeader
              handleClick={handleFilterValueClick}
              handleReset={handleReset}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default MarkMinerviniHeader;
